import * as moment from 'moment';
import 'moment/locale/da';
import {Order} from "./order";
import {ShipmentEvent, ShipmentEventInterface} from "./shipment-event";
import {Package, PackageInterface} from "./package";
import {ShipmentRoute} from "./shipment-route";
import {ShipmentService} from "./shipment-service";
import {OrderLineStatus, ShipmentProductLine, ShipmentProductLineInterface} from "./shipment-product-line";
import Moment = moment.Moment;
import {User} from "@hassel-it/angular-common";

export class Shipment {

    id: string;
    order?: Order = null;
    price_provider?: number;
    price_invoiced?: number;
    price_difference?: number;
    price_difference_pct?: number;
    margin_pct?: number;
    margin?: number;
    costprice_sum?: number;
    products_sum?: number;
    carrier?: string;
    carrier_code?: string;
    carrier_logo?: string;
    delivery_progress?: number;
    estimated_delivery_progress?: number;
    delivery_context?;
    delivery_labels?;
    order_reference?: string;
    external_reference?: string;
    nota_number?: number;
    rekv_number?: number;
    branch: string;
    label_print_date?: Moment;
    estimated_delivery?: Moment;
    actual_delivery?: Moment;
    real_margin?: number;
    real_margin_pct?: number;
    diff_pct?: number;
    order_date?: Moment;
    shipping_date?: Moment;
    shipment_events?: ShipmentEvent[];
    shipment_services?: ShipmentService[];
    shipment_packages?: Package[];
    shipment_route?: ShipmentRoute;
    shipment_address?;
    sender_address?;
    droppoint_address?;
    pickup_address?;
    shipment_addresses?;
    shipment_product_lines?: ShipmentProductLine[];
    shipment_status?: string;
    shipment_status_formatted?: string;
    shipment_route_id?;
    sorting?;
    picking_sorting?;
    shipment_priority?;
    is_protected?;
    is_return_shipment?: boolean;
    is_internal_shipment?: boolean;
    dropoff_time?: number;
    barcode?: string;
    user?: User;
    product_line_status?: string;
    product_line_status_formatted?: string;
    internal_comment?: string;
    comments?: string;
    provider?: string;
    placement?:string;
    weight_sum?:number;
    weight_warning?:boolean;
    contact_ref?:string;

    additional_reference?:string;
    pickup_instructions?:string;


    supports_dg?: boolean;

    is_private?: boolean;
    is_flex?: boolean;
    is_business?: boolean;
    is_droppoint?: boolean;

    group_child_shipments?: Shipment[];
    group_parent_shipment?: Shipment;

    /**
     * Virtuelle coordinater, bruges kun til kort
     */
    map_x?: number;
    map_y?: number;

    has_invalid_coords?:boolean;

    status_ordering?:number;
    static _JSONProps: string[] = [
        'id',
        'is_protected',
        'has_invalid_coords',
        'external_reference',
        'order_reference',
        'nota_number',
        'rekv_number',
        'branch',
        'comments',
        'carrier_code',
        'carrier_logo',
        'carrier',
        'delivery_progress',
        'estimated_delivery_progress',
        'delivery_context',
        'delivery_labels',
        'price_provider',
        'price_invoiced',
        'price_difference',
        'price_difference_pct',
        'margin_pct',
        'margin',
        'costprice_sum',
        'products_sum',
        'real_margin_pct',
        'real_margin',
        'diff_pct',
        'order_date',
        'shipping_date',
        'shipment_status',
        'shipment_status_formatted',
        'shipment_route_id',
        'sorting',
        'picking_sorting',
        'shipment_priority',
        'is_return_shipment',
        'is_internal_shipment',
        'dropoff_time',
        'barcode',
        'product_line_status_formatted',
        'product_line_status',
        'internal_comment',
        'provider',
        'placement',
        'map_x',
        'map_y',
        'status_ordering',
        'weight_sum',
        'contact_ref',
        'pickup_instructions',
        'additional_reference',
        'supports_dg',
        'is_private',
        'is_flex',
        'is_business',
        'is_droppoint',
        'weight_warning'
    ];

    constructor(initializer?: ShipmentJSON) {
        if (initializer === undefined) {
            return;
        }
    }

    static fromJSON(json: ShipmentJSON | string): Shipment {
        if (json === null) {
            return new Shipment();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, Shipment.reviver);
        } else {
            let task = Object.create(Shipment.prototype);

            let extra = {
                order: null,
                label_print_date: json.label_print_date ? moment(json.label_print_date) : null,


                estimated_delivery: json.estimated_delivery ? moment(json.estimated_delivery) : null,
                actual_delivery: json.actual_delivery ? moment(json.actual_delivery) : null,


                order_date: moment(json.order_date),
                shipping_date: moment(json.shipping_date),
                shipment_events: [],
                shipment_packages: [],
                shipment_services: [],
                child_shipments: [],
                parent_shipment: null,

                group_child_shipments: [],
                group_parent_shipment: null,

                shipment_product_lines: [],
                shipment_address: null,
                sender_address: null,
                droppoint_address: null,
                pickup_address: null,
                shipment_addresses: [],
                shipment_route: null,
                user: null
            };

            Object.keys(json).forEach((key, index) => {
                if (Shipment._JSONProps.indexOf(key) !== -1) {
                    task[key] = json[key];
                }

                if (key === 'order') {
                    extra.order = Order.fromJSON(json[key]);
                }

                if (key === 'shipment_events') {
                    json[key].forEach((value: ShipmentEventInterface, index) => {
                        extra.shipment_events.push(ShipmentEvent.fromJSON(value));
                    });
                }

                if (key === 'shipment_packages') {
                    json[key].forEach((value: PackageInterface, index) => {
                        extra.shipment_packages.push(Package.fromJSON(value));
                    });
                }

                if (key === 'shipment_product_lines') {
                    json[key].forEach((value: ShipmentProductLineInterface, index) => {
                        extra.shipment_product_lines.push(ShipmentProductLine.fromJSON(value));
                    });
                }

                if (key === 'shipment_services') {
                    json[key].forEach((value: ShipmentService, index) => {
                        extra.shipment_services.push(value);
                    });
                }

                if (key === 'child_shipments') {
                    json[key].forEach((value: Shipment) => {
                        extra.child_shipments.push(Shipment.fromJSON(value));
                    });
                }

                if (key === 'parent_shipment' && json[key] !== null && json[key] !== undefined) {
                    extra.parent_shipment = Shipment.fromJSON(json[key]);
                }



                if (key === 'group_child_shipments') {
                    json[key].forEach((value: Shipment) => {
                        extra.group_child_shipments.push(Shipment.fromJSON(value));
                    });
                }


                if (key === 'group_parent_shipment' && json[key] !== null && json[key] !== undefined) {
                    extra.group_parent_shipment = Shipment.fromJSON(json[key]);
                }


                if (key === 'shipment_addresses') {
                    json[key].forEach((value: any, index) => {
                        extra.shipment_addresses.push(value);
                    });
                }

                if (key === 'shipment_address') {
                    extra.shipment_address = json[key];
                }

                if (key === 'sender_address' && json[key] !== '') {
                    extra.sender_address = json[key];
                }

                if (key === 'droppoint_address') {
                    extra.droppoint_address = json[key];
                }

                if (key === 'pickup_address') {
                    extra.pickup_address = json[key];
                }

                if (key === 'shipment_route') {
                    extra.shipment_route = ShipmentRoute.fromJSON(json[key]);
                }

                if (key === 'user') {
                    extra.user = User.fromJSON(json[key]);
                }
            });

            return Object.assign(task, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === "" ? Shipment.fromJSON(value) : value;
    }

    public formattedDate?(field: string, format: string) {
        if (this[field]) {
            const thisField: Moment = this[field];
            if (thisField.isValid()) {
                return this[field].format(format);
            }
        }
    }

    public formattedStatus?(): string {
        return this.shipment_status_formatted;
    }

    public productLinesStatusLabel?() {
        let status = this.getProductLinesStatus()
        if (status === OrderLineStatus.Ok) {
            return 'OK';
        }
        return 'Problemer';
    }

    public productLinesStatusColor?() {
        let color = 'status-box--red';
        if (this.shipment_product_lines) {
            let states: OrderLineStatus[] = [];
            this.shipment_product_lines.forEach((line) => {
                states.push(line.orderLineStatus());
            });
            states = states.sort();
            if (states) {
                let higestError = states[states.length - 1];

                if (higestError === OrderLineStatus.Ok) {
                    color = 'status-box--green';
                } else if (higestError === OrderLineStatus.Warning) {
                    color = 'status-box--orange';
                } else if (higestError === OrderLineStatus.Error) {
                    color = 'status-box--red';
                } else {
                    color = 'status-box--gray';
                }

            }
        }

        let rt = {};
        rt[color] = true;

        return rt;

    }

    public getProductLinesStatus?(): OrderLineStatus {
        if (this.shipment_product_lines) {
            let states: OrderLineStatus[] = [];
            this.shipment_product_lines.forEach((line) => {
                states.push(line.orderLineStatus());
            });
            states = states.sort();
            if (states) {
                let higestError = states[states.length - 1];
                return higestError;
            }
        }

        return OrderLineStatus.Unknown;
    }

    public isDroppoint?(): boolean {
        return this.shipment_services.filter((service) => {
            return service.service_code === 'droppoint';
        }).length > 0;
    }

    public isReturnShipment?(): boolean {
        if (this.nota_number && this.nota_number.toString().match(/retur/i)) {
            return true;
        }
        if (this.is_return_shipment) {
            return true;
        }
        return false;
    }

    public checkUn?() {
        if (this.supports_dg && this.shipment_product_lines) {
            return this.shipment_product_lines.filter((line) => {
                if (line.dg_un) {
                    return true;
                }
            }).length > 0;
        }
        return false;
    }
}

// color = 'status-box--extra1';
// color = 'status-box--extra1';
// color = 'status-box--extra1';

// A representation of Token data that can be converted to
// and from JSON without being altered.
export interface ShipmentJSON extends Shipment {
}
